import React, { useCallback, useEffect, useState } from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import { Link, Route, useLocation, useParams } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import UserDetails from './userDetails'
import UserTransactions from './userTransactions'

const User = () => {
	const { userId } = useParams<any>()
	const { pathname } = useLocation()

	const [user, setUser] = useState<any>()

	useEffect(
		() => {
			firebase.firestore().doc(`users/${userId}`).onSnapshot(snapshot => {
				setUser(snapshot.data())
			})
		},
		[userId]
	)

	const pathSelectedClass = useCallback(
		(pattern: RegExp) => {
			if (pattern.test(pathname)) {
				return 'border-b-2 border-black text-black pb-2'
			}

			return undefined
		},
		[pathname]
	)

	return (
		<div className="container mx-auto">
			<div>
				<Link className="flex items-center group mb-2" to={{ pathname: '/users' }}>
					<FaChevronLeft className="text-black group-hover:text-red-600" />
					<div className="ml-2 text-sm font-semibold group-hover:text-red-600">Users</div>
				</Link>
				<h2>{user?.firstName} {user?.lastName}</h2>
				<div className="mt-4 mb-6 font-semibold text-sm text-gray-500">
					<a className={`${pathSelectedClass(/users\/[a-zA-Z0-9]+$/)} hover:text-black`} href={`/users/${userId}`}>
						User Details
					</a>
					<a className={`${pathSelectedClass(/users\/[a-zA-Z0-9]+\/transactions$/)} ml-4 hover:text-black`} href={`/users/${userId}/transactions`}>
						Transactions
					</a>
				</div>
				<Route exact path={`/users/${userId}`}>
					<UserDetails userId={userId} user={user} />
				</Route>
				<Route path={`/users/${userId}/transactions`}>
					<UserTransactions userId={userId} />
				</Route>
			</div>
		</div>
	)
}

export default User
